module.exports = __webpack_public_path__ + "static/media/Impreza-GV-WRX.a1d8d177.webp";